const values = [
  {
    icon: 'ri-focus-3-line',
    title: '定位清晰',
    desc: '只做爆料与调查类内容，不混入无关的信息流。频道划分尽量贴近读者的实际关注点。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '核实优先',
    desc: '宁可慢一点，也要把信源交代清楚。无法核实的说法会明确标注，而不是当作结论发布。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '双向呈现',
    desc: '涉及具体当事方时，会同步呈现其回应与说明，让读者自己判断，而不是只给单方面叙述。',
  },
];

const principles = [
  {
    no: '01',
    title: '以公开信息为基础',
    desc: '所有报道的起点都是可查询、可追溯的公开信息，包括公示记录、公开回应、公开数据与当事人陈述。',
  },
  {
    no: '02',
    title: '关键指控需双信源',
    desc: '当内容涉及对具体主体的明确指控时，至少需要两个相互独立的信源交叉验证才会发布。',
  },
  {
    no: '03',
    title: '当事方回应同等呈现',
    desc: '在发布前尽力联系当事方，若获得回应，会在同一篇文章中以同等显著的篇幅呈现其说法。',
  },
  {
    no: '04',
    title: '可修订、可追溯',
    desc: '发现内容有误时及时更正，并在原文标注修改说明与时间，保留修改记录供读者核对。',
  },
];

export default function Principles() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4 flex flex-col gap-5">
            <span className="inline-flex w-fit items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-flag-2-line" aria-hidden="true" />
              发展理念与内容原则
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              先把规则说清楚，再谈内容好不好看
            </h2>
            <div className="flex flex-col gap-4 mt-2">
              {values.map((item) => (
                <div key={item.title} className="flex gap-4 rounded-lg border border-background-300/60 bg-background-50 p-4 md:p-5">
                  <span className="w-10 h-10 shrink-0 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                    <i className={`${item.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <div className="flex flex-col gap-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="text-xs md:text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {principles.map((p) => (
                <article key={p.no} className="flex flex-col gap-3 rounded-lg border border-background-300/60 bg-background-50 p-5 md:p-6">
                  <span className="font-heading text-3xl font-black text-primary-200">{p.no}</span>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}